import React, {useState, useEffect} from 'react';
import { Pressable, View } from 'react-native'

import tw from '../../styles/tailwind';
import Text from '../../components/Text';
import Icon from '../../components/IcomoonIcon';


import { actions } from '../../store/Reducers/auth';
import Constants from 'expo-constants'
import { useDispatch, useSelector } from 'react-redux';
import { Ionicons } from '@expo/vector-icons';
import * as Application from 'expo-application';



export default function SettingsScreen({navigation}) {
  const dispatch = useDispatch()

  const [showDebug, setShowDebug] = useState(0);
  const state = useSelector(state => state.status)

  


  return (
    <View style={tw`flex-1 py-4 pb-26`}>
      <View style={tw`flex-1`}>
        <Text style={tw`text-center text-lg`}>{state.user?.name}</Text>
        <Text style={tw`text-center text-gray-400`}>{state.user?.email}</Text>
      </View>

      <View style={tw``}>
        {/* Botón soporte */}
        <Pressable
          style={({ pressed }) => tw.style(`row bg-gray-200/50 w-full py-2.5 px-4 border-b border-gray-200`, pressed && `opacity-50`)}
          onPress={() => navigation.navigate("Support.Index")}
        >
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-600`}>Soporte</Text>
            <Text style={tw`text-gray-400`}>¿Necesitas ayuda?</Text>
          </View>

          <Ionicons name="help-circle-outline" size={20} color={tw.color('gray-500')} style={tw`mr-2`} />
        </Pressable>

        <Pressable
          style={({pressed}) => tw.style(`bg-gray-200/50 w-full py-2.5 px-4 border-b border-gray-200`, pressed && `opacity-50`)}
          onPress={() => navigation.navigate("ToS.Privacy")}
        >
          <Text style={tw`text-gray-600`}>Privacidad</Text>
        </Pressable>

        <Pressable
          style={({pressed}) => tw.style(`bg-gray-200/50 w-full py-2.5 px-4 border-b border-gray-200`, pressed && `opacity-50`)}
          onPress={() => { dispatch(actions.logout()) }}
        >
          <Text style={tw`text-gray-400`}>Cerrar sesión</Text>
        </Pressable>


        <Text style={tw`text-gray-300 text-center mt-4 mb-2`} onPress={() => setShowDebug(showDebug + 1)}>v{Constants.expoConfig?.version}</Text>

        {
          showDebug > 0 &&
            <View>
              <Text style={tw`text-gray-300 text-center mt-4 mb-2`}>nativeApplicationVersion: v{Application.nativeApplicationVersion}.</Text>
              <Text style={tw`text-gray-300 text-center`}>{Constants.expoConfig?.extra?.API_URL}</Text>
            </View>
        }
      </View>

    </View>

  );
}
